<template>
  <div class="wrapper">
    <div class="top">
      <van-notice-bar class="serverTime" :left-icon="require('../../assets/images/index/kfNotice.png')" color="#FF6010"
        :text="noticeStr" v-if="active == 0&& noticeStr " @click="noticeShow = true" />
      <van-popup v-model="noticeShow" :close-on-click-overlay="false" style="background: transparent">
        <div class="noticeBox">
          <div class="title">公告通知</div>
          <div class="contentArea">
            <div class="content">
              <span>{{ noticeStr }}</span>
            </div>
          </div>
          <div class="checkBtn" @click="noticeShow = false">我知道了</div>
        </div>
      </van-popup>
      <div class="boxContainer">
        <div class="itemBox">
          <div class="list">
            <div class="item" v-if="detail.commodity">
              <img :src="detail.commodity.commodity_logo" alt />
              <div class="rightArea">
                <span class="more-h commodityName">{{
                  detail.commodity.commodity_name
                  }}</span>
                <span class="more-h property">规格：{{ detail.commodity.property }}</span>
                <div class="last">
                  <span class="price">￥{{ detail.commodity.sell_price }}</span>
                  <span class="quantity">x{{ detail.commodity.quantity }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="postAddress" v-if="active == 1&&detail.address && detail.address.contact_self">
        <span class="postKey" style="color: #333">退货地址:</span>
        <div class="right">
          <div class="postTop">
            <div class="left">
              <span style="margin-right: 0.1rem">{{
                detail.address.contact_self
                }}</span>
              <span>{{
                detail.address.phone_no_self
                }}</span>
            </div>
            <div class="copyBtn" @click="copy" data-clipboard-action="copy"
              :data-clipboard-text="`${detail.address.contact_self},${detail.address.phone_no_self},${detail.address.province_self}${detail.address.city_self}${detail.address.district_self}${detail.address.address_self}`">
              <span>复制地址</span>
            </div>
          </div>
          <span style="word-break: break-all; line-height: 0.32rem">{{ detail.address.province_self }}{{
            detail.address.city_self
            }}{{ detail.address.district_self
            }}{{ detail.address.address_self }}</span>
        </div>
      </div>
      <div v-if="active==0&&detail.address && detail.address.contact" class="pickAddress">
        <div class="flexItem">
          <div class="pickItemLeft">
            <div class="line"></div>
            <div class="circle" style="background:#FF4671">
              <span>取件</span>
              <span>地址</span>
            </div>
            <div class="line" style="background:#FF4671"></div>
          </div>
          <div class="pickItemRight" v-if="selectaddress.address" @click="toAddress">
            <div class="flexItem" style="height:.37rem;">
              <span>{{ selectaddress.contacts }}</span>
              <div class="flexItem" style=" justify-content: flex-start;height:.37rem;">
                <span>{{ selectaddress.phone_no }}</span>
                <img class="arrow" src="../../assets/images/icon_youjiantou.svg" alt />
              </div>
            </div>
            <div class="addressDesc">
              {{ selectaddress.province }}{{ selectaddress.city
              }}{{ selectaddress.district }}{{ selectaddress.address }}
            </div>
          </div>
          <div v-else class="pickItemRight"
            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;"
            @click="toAddress">
            <span>请选择取件地址</span>
            <img class="arrow" src="../../assets/images/icon_youjiantou.svg" alt />
          </div>
        </div>
        <div class="flexItem">
          <div class="pickItemLeft">
            <div class="line" style="background:#333"></div>
            <div class="circle" style="background:#333">
              <span>退回</span>
              <span>地址</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="pickItemRight" style="border-top:1px solid #d0d0d0;">
            <div class="flexItem" style="height:.37rem;">
              <span>{{ detail.address.contact }}</span>
              <div class="flexItem" style=" justify-content: flex-start;height:.37rem;">
                <span>{{ detail.address.phone_no }}</span>
              </div>
            </div>
            <div class="addressDesc">
              {{ detail.address.province }}{{ detail.address.city
              }}{{ detail.address.district }}{{ detail.address.address }}
            </div>
          </div>
        </div>
      </div>
      <div class="itemSelect" v-if="active == 0 || active == 1">
        <!-- <div class="title" v-if="menuShow">
          <span
            @click="active = 0"
            :class="active == 0 ? 'active span' : 'span'"
            >上门取件</span
          >
          <span
            @click="active = 1"
            :class="active == 1 ? 'active span' : 'span'"
            >自己寄件</span
          >
        </div> -->
        <!--上门取件-->
        <div v-if="active == 0">
          <!-- <div class="item">
            <span class="key">取件地址</span>
            <div class="selectRight" @click="toAddress">
              <div style="flex: 1" v-if="selectaddress.address">
                <div class="flex">
                  <span>{{ selectaddress.contacts }}</span>
                  <span>{{ selectaddress.phone_no }}</span>
                </div>
                <div style="margin-top: 0.1rem; word-break: break-all">
                  {{ selectaddress.province }}{{ selectaddress.city
                  }}{{ selectaddress.district }}{{ selectaddress.address }}
                </div>
              </div>
              <span v-else>请选择详细地址</span>
              <img src="../../assets/images/icon_youjiantou.svg" alt />
            </div>
          </div> -->
          <div class="item">
            <span class="key">上门时间</span>
            <div class="selectRight" @click="timeShowClick">
              <span v-if="time != -1">预约 {{ timeArr[parseInt(Number(time) / 10)].text
                }}{{
                timeArr[parseInt(Number(time) / 10)].times[Number(time) % 10]
                .timeStr
                }}</span>
              <span v-else>请选择上门取件时间</span>
              <img src="../../assets/images/icon_youjiantou.svg" alt />
            </div>
          </div>
          <div class="item">
            <span class="key">物品类型</span>
            <div class="selectRight" @click="typePickerShow = true">
              <span v-if="goodsType">{{ goodsTypeStr || "" }}</span>
              <span v-else>请选择物品类型</span>
              <img src="../../assets/images/icon_youjiantou.svg" alt />
            </div>
          </div>
          <div class="item" style="height: 0.9rem; box-sizing: border-box; align-items: center">
            <span class="key">包裹重量</span>
            <div class="selectInput">
              <div class="less" @click="weightChange(-1)">-</div>
              <input type="text" v-model="weightText" readonly />
              <div class="more" @click="weightChange(1)">+</div>
            </div>
          </div>
          <div class="item" style="height: 0.9rem; box-sizing: border-box; align-items: center">
            <span class="key">运费评估</span>
            <div class="selectRight">
              <span class="predict"><span>￥</span>{{ expressPrice }}</span>
            </div>
          </div>
          <div class="tip">
            <span>运费以当前重量评估，实际运费与快递员确认重量为准</span>
          </div>
          <!-- <div class="agree">
            <div :class="agree?'radius active':'radius'" @click="agree = !agree "></div>
            <div class="agreeText" @click="agree = !agree ">
              我已阅读并同意
              <span>《服务协议》</span>
            </div>
          </div>-->
        </div>
        <!--自己寄件-->
        <div v-else-if="active == 1">
          <div class="expressTitle">请填写物流信息</div>
          <div class="expressInput">
            <input type="text" @click="expressPickerShow = true" v-model="expressName" placeholder="请选择快递公司" readonly />
            <input v-model="expressId" style="margin-top: 0.24rem" type="text" placeholder="请输入物流单号" />
          </div>
          <div class="uploadWrap" v-if="parseFloat(detail.postage_safe || '0') > 0">
            <div v-if="this.detail.is_full_postage_pay == '1'" class="expressTitle" style="height: 1rem">
              上传运费支付凭证
            </div>
            <div v-if="this.detail.is_full_postage_pay == '1'" class="photoArea">
              <van-uploader :after-read="upload" accept="image/*" :before-read="beforeRead" class="photoItem">
                <div class="photoCenter" v-if="voucherImg">
                  <img class="img" :src="voucherImg" alt="" />
                </div>
                <div class="photoCenter" v-else>
                  <img class="icon" src="./../../assets/images/replacementdetail/uploadImg.png" alt="" />
                </div>
              </van-uploader>
            </div>
            <div class="expressTitle" style="height: 1rem; border: none">
              上传支付宝信息
            </div>
            <!--  aliName aliAccount -->
            <div class="expressInput" style="padding-bottom: 0">
              <input v-model="aliName" type="text" placeholder="请输入支付宝姓名" />
              <input v-model="aliAccount" style="margin-top: 0.24rem" type="text" placeholder="请输入支付宝账号" />
            </div>
          </div>
          <div class="expressNotice">
            <span v-if="parseFloat(detail.postage_safe || '0') > 0">请填写有效的费用凭证，有助于客服审查，并后续补偿运费款项。</span>
            <span v-if="parseFloat(detail.postage_safe || '0') > 0">1:请勿邮寄到付，以免商家拒收</span>
            <span v-if="parseFloat(detail.postage_safe || '0') > 0">2:寄回快递签收后48小时内，完成运费险赔付：{{
              detail.postage_pay
              }}元</span>
            <span>请仔细填写您寄出快递的信息，确保我们能够跟进并且收到您的商品。</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomC">
      <div class="bottom">
        <!-- <div class="notice" v-if="active==0">运费以当前重量评估，实际运费与快递员确认重量为准</div> -->
        <div class="bRight">
          <!-- <span v-if="active==0">运费预估</span>
          <span class="expressPrice" v-if="active==0">￥{{(expressPrice).toFixed(2)}}</span>-->
        </div>
        <van-button :class="allTrue ? 'apply active' : 'apply'" v-if="active == 0 || active == 1" :disabled="!allTrue"
          @click="postData">提交订单</van-button>
      </div>
    </div>
    <!--选择物流-->
    <van-popup style="background: transparent" v-model="expressPickerShow" position="bottom" :overlay="true">
      <van-picker title="快递选择" show-toolbar :columns="addressData" @confirm="expressConfirm"
        @cancel="expressPickerShow = false" @change="expressChange" />
    </van-popup>

    <!--选择商品类型-->
    <van-popup style="background: transparent" v-model="typePickerShow" position="bottom" :overlay="true">
      <van-picker show-toolbar :columns="typeData" @confirm="typeConfirm" @cancel="typePickerShow = false" />
    </van-popup>

    <!--选择预约时间-->
    <van-popup style="background: transparent" v-model="timeShow" position="bottom" :overlay="true">
      <div class="timeBox">
        <div class="timeTitle">上门时间</div>
        <img @click="timeShow = false" class="xpng" src="../../assets/images/x.png" alt />
        <div class="timeMain">
          <div class="timeMainLeft">
            <div v-for="(item, index) in timeArr" @click="day = index"
              :class="day == index ? 'timeKey active' : 'timeKey'">
              {{ item.text }}
            </div>
          </div>
          <div class="timeMainRight" v-if="timeArr[day] && timeArr[day].times">
            <div v-for="(timeItem, timeIndex) in timeArr[day].times" @click="timeClick(timeIndex)" :class="
                time == day + '' + timeIndex ? 'timeValue active' : 'timeValue'
              ">
              {{ timeItem.timeStr }}
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="pickPayShow" style="border-radius: 0.24rem">
      <div class="reminder">
        <img class="reminderimg" src="./../../assets/images/ii.png" alt />
        <p class="reminderTitle">温馨提示</p>
        <p class="reminderDesc">
          {{
          active==0 && parseFloat(detail.postage_safe || '0') > 0 &&
          detail.is_full_postage_pay=='0'?'本订单将会按照运费险协议补偿运费，自动用于支付寄回运费。如实际支付运费超出运费险协议金额，则需自行补齐余下运费。':
          active==0 && parseFloat(detail.postage_safe || '0') > 0 &&
          detail.is_full_postage_pay=='1'?'本订单由于是商品质量问题，平台将为您全额承担运费，无需您支付。':
          active==0 && parseFloat(detail.postage_safe || '0') <= 0 && detail.is_full_postage_pay=='1'
            ?'本订单由于是商品质量问题，平台将为您全额承担运费，无需您支付。': active==1 && parseFloat(detail.postage_safe || '0' )> 0 &&
            detail.is_full_postage_pay=='0'?'本订单由于是非商品质量问题，该订单将会按照运费险协议补偿运费，您先垫付寄回运费，然后按步骤提交运费支付凭证和支付宝收款账号，待平台审核后，为您赔付到您提供的支付宝账户内':
            active==1 && parseFloat(detail.postage_safe || '0') > 0 &&
            detail.is_full_postage_pay=='1'?'本订单由于是商品质量问题，平台将为您全额承担运费，您先垫付寄回运费，然后按步骤提交运费凭证和支付宝收款账号，待平台审核后，为您赔付到您提供的支付宝账户内':
            active==1 && parseFloat(detail.postage_safe || '0') <= 0 && detail.is_full_postage_pay=='1'
              ?'本订单由于是商品质量问题，平台将为您全额承担运费，您先垫付寄回运费，然后按步骤提交运费凭证和支付宝收款账号，待平台审核后，为您赔付到您提供的支付宝账户内':'' }} </p>
              <div class="reminderBtn" @click.stop="pickPayShow=false">
                <span>确认</span>
              </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import weChatShareApi from "../../assets/js/weChatShare";
  import {
    handleText,
    photoCompress,
    dataURLtoFile,
  } from "./../../assets/js/tool";
  import kdnExpress from "./../../assets/js/kdnExpress.json";
  import OSS from "ali-oss";
  import ObsClient from "esdk-obs-browserjs/src/obs";

  export default {
    components: {},
    props: {},
    mixins: [weChatShareApi],
    data() {
      return {
        type: "0",
        orderNbr: "", //订单编号
        active: -1,
        menuShow: false,
        agree: true,
        goodsType: "",
        goodsTypeStr: "",
        weight: 1,
        expressPrice: "0.0",
        allTrue: false,
        keepAlive: false,
        timeShow: false,
        expressPickerShow: false,
        addressData: [],
        kdnExpress: kdnExpress,
        exressIndex: -1,
        timeArr: [],
        day: 0,
        time: -1,
        noTime: 0,
        expressName: "",
        expressId: "",
        countTime: "00:00:00",
        specialArea: [
          "甘肃省",
          "青海省",
          "宁夏省",
          "陕西省",
          "辽宁省",
          "吉林省",
          "黑龙江省",
          "海南省",
          "西藏自治区",
          "新疆维吾尔自治区",
        ],
        detail: {},
        typePickerShow: false,
        typeData: [
          {
            text: "衣服",
            value: "1",
          },
          {
            text: "日用品",
            value: "2",
          },
          {
            text: "电器",
            value: "3",
          },
          {
            text: "化妆品",
            value: "4",
          },
          {
            text: "贴身衣物",
            value: "5",
          },
          {
            text: "其他",
            value: "6",
          },
        ],
        voucherImg: "",
        aliName: "",
        aliAccount: "",
        noticeStr: "提醒：因受疫情影响，部分地区暂时无法提供上门取件服务，请在疫情管制解除后再进行预约。",
        noticeShow: false,
        pickPayShow: false,
        buttonClick: true,
      };
    },
    watch: {
      selectaddress(val) {
        let hour = new Date().getHours();
        let addressType = this.specialArea.includes(val.province);
        if (
          addressType &&
          ((hour < 11 && Number(this.time) < 3) || Number(this.time) < 10)
        ) {
          this.time = 0;
        }
      },
      $route(to, from) {
        this.keepAlive = from.name == "addresslist";
      },
      active() {
        this.checkTrue();
      },
      expressName() {
        this.checkTrue();
      },
      expressId() {
        this.checkTrue();
      },
      agree() {
        this.checkTrue();
      },
      goodsType() {
        this.checkTrue();
      },
    },
    computed: {
      ...mapGetters(["selectaddress"]),
      weightText() {
        return this.weight + "KG";
      },
    },
    methods: {
      beforeRead(file) {
        if (
          file.type == "image/jpeg" ||
          file.type == "image/jpg" ||
          file.type == "image/png"
        ) {
          return true;
        } else {
          this.$toast({ message: `请上传图片格式为jpg，jpeg，png！` });
          return false;
        }
      },
      uploadPath(path, file) {
        // let name = file.name.replace("wxfile://", "");
        // let random = Math.round(Math.random() * 100000);
        // ${name.split(".")[0]}
        return `${path}/${this.userInfo.nbr}-${new Date().getTime()}.${file.type.split("/")[1]
          }`;
      },
      upload(file) {
        const that = this;
        let toast = this.$toast.loading({
          duration: 0,
        });
        let quality = Number((1048576 / file.file.size).toFixed(1)); //压缩到1m以内  算出压缩比例
        photoCompress(file.file, callback, quality); //将图片进行压缩
        function callback(res) {
          let newFile = dataURLtoFile(res, file.file.name);
          let url = that.uploadPath("images/user", newFile);
          if (that.uplaodServer == 'aliyun') {
            that.$post("/api/customer/getOSSToken", {
              userNbr: that.userInfo.nbr,
              token: "123456",
            })
              .then((data) => {
                let OSSToken = data.object.resp;
                if (OSSToken.resp_code == 0 && OSSToken.resp_result == 0) {
                  let client = new OSS({
                    //            region: '购买的区域',
                    endpoint: OSSToken.endpoint,
                    bucket: OSSToken.bucketName,
                    accessKeyId: OSSToken.accessKeyId,
                    accessKeySecret: OSSToken.accessKeySecret,
                    stsToken: OSSToken.securityToken,
                  });
                  client.options.endpoint.protocol = "https:";
                  client
                    .put(url, newFile)
                    .then((data) => {
                      let imgUrl = that.cdnImgPath + "/" + data.name;
                      that.voucherImg = imgUrl;
                      that.$forceUpdate();
                      toast.clear();
                    })
                    .catch((error) => {
                      toast.clear();
                      that.$toast({
                        message: "上传失败",
                        duration: 2000,
                      });
                    });
                } else {
                  that.$toast({
                    message: OSSToken.resp_msg,
                    duration: 2000,
                  });
                }
              })
              .catch((err) => {
                that.$toast({
                  message: err.message,
                  duration: 2000,
                });
              });
          } else {
            that.$post("/api/customer/getObsToken", {
              userNbr: that.userInfo.nbr,
              token: "123456",
            })
              .then((data) => {
                let OBSToken = data.object.resp;
                if (OBSToken.resp_code == 0 && OBSToken.resp_result == 0) {
                  let client = new ObsClient({
                    access_key_id: OBSToken.accessKeyId,
                    secret_access_key: OBSToken.accessKeySecret,
                    server: OBSToken.endpoint,
                    security_token: OBSToken.securityToken,
                    timeout: 3000, // 设置超时时间
                  });
                  client.putObject(
                    {
                      Bucket: OBSToken.bucketName, // 桶名
                      Key: url, // 文件名
                      SourceFile: newFile,
                    },
                    function (err, result) {
                      if (err) {
                        toast.clear();
                        that.$toast({
                          message: "上传失败",
                          duration: 2000,
                        });
                      } else {
                        if (result.CommonMsg.Status < 300) {
                          let imgUrl = that.cdnImgPath + "/" + url;
                          that.voucherImg = imgUrl;
                          that.$forceUpdate();
                          toast.clear();
                        }
                      }
                    }
                  );
                } else {
                  that.$toast({
                    message: OBSToken.resp_msg,
                    duration: 2000,
                  });
                }
              })
              .catch((err) => {
                that.$toast({
                  message: err.message,
                  duration: 2000,
                });
              });
          }
        }
      },

      /*超区校验接口 
      /kdniao/checkOrderTime
      {
        receiverProvince:"浙江省",收
        receiverCity:"杭州市",
        receiverArea:"滨江区",
        senderProvince:"上海市",发
        senderCity:"市辖区",
        senderArea:"金山区"
      }
      
  
      单渠道预估运费接口
      /kdniao/shippingEstimate
      {
        receiverProvince:"浙江省",
        receiverCity:"杭州市",
        receiverArea:"滨江区",
        senderProvince:"上海市",
        senderCity:"市辖区",
        senderArea:"金山区",
        weight:1
      }
      */
      getkdniaoTime() {
        let that = this;
        this.$post("/api/kdniao/checkOrderTime", {
          receiverProvince: this.detail.address.province,
          receiverCity: this.detail.address.city,
          receiverArea: this.detail.address.district,
          senderProvince: this.selectaddress.province,
          senderCity: this.selectaddress.city,
          senderArea: this.selectaddress.district,
        })
          .then((res) => {
            let resp = res.object ? res.object.resp : {};
            if (res.code == "200") {
              if (resp.resp_code == "0" && resp.resp_result == "0") {
                let obj = {};
                resp.times.forEach((item) => {
                  item.stamp = new Date(item.EndFetchTime.replace(/\-/g, "/"));
                  item.date = item.EndFetchTime.substring(0, 10);
                  item.timeStr =
                    item.StartTime.substring(11, 16) +
                    "-" +
                    item.EndTime.substring(11, 16);
                  if (obj[item.date]) {
                    obj[item.date].push(item);
                  } else {
                    obj[item.date] = [];
                    obj[item.date].push(item);
                  }
                });
                let timeArr = that.timeArr;
                for (let key in obj) {
                  for (let i = 0; i < timeArr.length; i++) {
                    if (timeArr[i].date == key) timeArr[i].times = obj[key];
                  }
                }
                (that.time = -1), (that.timeArr = timeArr);
              } else {
                that.$toast({
                  message: resp.resp_msg,
                  duration: 2000,
                });
              }
            } else {
              that.$toast({
                message: res.data.message,
                duration: 2000,
              });
            }
          })
          .catch((err) => {
            that.$toast({
              message: err.message,
              duration: 2000,
            });
          });
      },
      predictPrice() {
        let that = this;
        this.$post("/api/kdniao/shippingEstimate", {
          receiverProvince: this.detail.address.province,
          receiverCity: this.detail.address.city,
          receiverArea: this.detail.address.district,
          senderProvince: this.selectaddress.province,
          senderCity: this.selectaddress.city,
          senderArea: this.selectaddress.district,
          weight: this.weight,
        })
          .then((res) => {
            let resp = res.object ? res.object.resp : {};
            if (res.code == "200") {
              if (resp.resp_code == "0" && resp.resp_result == "0") {
                that.expressPrice = parseFloat(resp.cost).toFixed(2);
              } else {
                that.$toast({
                  message: resp.resp_msg,
                  duration: 2000,
                });
              }
            } else {
              that.$toast({
                message: res.data.message,
                duration: 2000,
              });
            }
          })
          .catch((err) => {
            that.$toast({
              message: err.message,
              duration: 2000,
            });
          });
      },
      typeConfirm(item, index) {
        this.goodsType = item.value;
        this.goodsTypeStr = item.text;
        this.typePickerShow = false;
      },
      copy() {
        let copyBtn = new this.$clipboard(".copyBtn");
        copyBtn.on("success", (e) => {
          this.$toast({
            message: "复制成功",
            duration: 2000,
          });
        });
        copyBtn.on("error", (e) => {
          this.$toast({
            message: "复制失败",
            duration: 2000,
          });
        });
      },
      expressConfirm(value, index) {
        this.exressIndex = index;
        this.expressName = value;
        this.expressPickerShow = false;
      },
      expressChange() { },
      checkTrue() {
        if (
          (this.active == 0 &&
            this.selectaddress.nbr &&
            parseFloat(this.time) >= 0 &&
            this.agree &&
            this.goodsType) ||
          (this.active == 1 && this.expressName && this.expressId)
        ) {
          this.allTrue = true;
        } else {
          this.allTrue = false;
        }
      },
      toAddress() {
        this.$router.push({ path: "/addresslist", query: { address: 1 } });
      },
      postData() {
        let that = this
        if (!that.buttonClick) return false;
        that.buttonClick = false;

        // 用户填写物流
        let toast = this.$toast.loading({ mask: true, duration: 0 });
        if (this.active == 0) {
          let left = Number(this.time.split("")[0]);
          let right = Number(this.time.split("")[1]);
          let startDate = this.timeArr[left].times[right].StartTime;
          let endDate = this.timeArr[left].times[right].EndTime;
          this.$post("/api/kdniao/orderOnline", {
            userNbr: this.userInfo.nbr,
            refundNbr: this.$route.query.nbr,
            addressNbr: this.selectaddress.nbr,
            startDate: startDate,
            endDate: endDate,
            weight: this.weight,
            type: this.goodsType,
          })
            .then((res) => {
              let resp = res.object ? res.object.resp : {};
              that.buttonClick = true
              if (res.code == "200") {
                if (resp.resp_code == "0" && resp.resp_result == "0") {
                  this.$toast({
                    message: "提交成功",
                    duration: 2000,
                  });
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 500);
                } else {
                  this.$toast({
                    message: resp.resp_msg,
                    duration: 2000,
                  });
                }
              } else {
                this.$toast({
                  message: res.message,
                  duration: 2000,
                });
              }
            })
            .catch((err) => {
              that.buttonClick = true
              this.$toast({
                message: err.message,
                duration: 2000,
              });
            });
        }
        if (this.active == 1) {
          let voucherImg = this.voucherImg || "";
          let aliName = this.aliName || "";
          let aliAccount = this.aliAccount || "";
          let is_full_postage_pay = this.detail.is_full_postage_pay;
          let postage_safe = parseFloat(this.detail.postage_safe || "0");
          if (postage_safe > 0 && is_full_postage_pay == "1" && !voucherImg)
            return this.$toast({
              message: "上传运费支付凭证",
              duration: 2000,
            });
          if (postage_safe > 0 && is_full_postage_pay == "1" && !aliName)
            return this.$toast({
              message: "请输入支付宝姓名",
              duration: 2000,
            });
          if (postage_safe > 0 && is_full_postage_pay == "1" && !aliAccount)
            return this.$toast({
              message: "请输入支付宝账号",
              duration: 2000,
            });
          this.$post("/api/customer/refundOrder/inputRefundExpressNew", {
            refundNbr: this.$route.query.nbr,
            refundExpressId: this.expressId,
            refundExpressName: this.expressName,
            refundExpressImage: voucherImg,
            postagePayName: aliName,
            postagePayAccount: aliAccount,
          })
            .then((data) => {
              that.buttonClick = true
              if (data.code == "200") {
                let resp = data.object.resp;
                if (resp.resp_code == "0" && resp.resp_result == "0") {
                  this.$toast({
                    message: "提交成功",
                    duration: 2000,
                  });
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 500);
                } else {
                  this.$toast({
                    message: resp.resp_msg,
                    duration: 2000,
                  });
                }
              } else {
                this.$toast({
                  message: data.message,
                  duration: 2000,
                });
              }
            })
            .catch((err) => {
              that.buttonClick = true
              toast.clear();
              this.$toast({
                message: err.message,
                duration: 2000,
              });
            });

          // this.$commonPost({
          //   jydm: "flow_40006",
          //   flow_40006: {
          //     nbr: this.$route.query.nbr,
          //     refund_express_id: this.expressId,
          //     refund_express_name: this.expressName,
          //     refund_express_note: "",
          //   },
          // })
          //   .then((response) => {
          //     this.$toast({
          //       message: "提交成功",
          //       duration: 2000,
          //     });
          //     setTimeout(() => {
          //       this.$router.go(-1);
          //     }, 500);
          //   })
          //   .catch((err) => {
          //     toast.clear();
          //     this.$toast({
          //       message: err.message,
          //       duration: 2000,
          //     });
          //   });
        }
      },
      timeShowClick() {
        if (!this.selectaddress.address) {
          return this.$toast({ message: "请先选择取件地址", duration: 2000 });
        }
        // let hour = new Date().getHours();
        // let addressType = this.specialArea.includes(this.selectaddress.province);
        // if (addressType && hour < 11) {
        //   this.timeShow = true;
        //   return (this.noTime = 3);
        // } else if (addressType) {
        //   this.day = Math.max(parseInt(Number(this.time) / 10), 1);
        //   this.timeShow = true;
        //   return (this.noTime = 5);
        // } else {
        //   this.day = parseInt(Number(this.time) / 10);
        // }
        // this.checkDate();
        this.timeShow = true;
      },
      weightChange(num) {
        if ((this.weight <= 1 || this.weight >= 30) && num < 0) return false;
        this.weight += num;
        this.predictPrice();
      },
      getAddress() {
        // 用户的默认地址
        this.$commonPost({
          jydm: "flow_10010",
          flow_10010: {
            user_nbr: this.userInfo.nbr,
          },
        })
          .then((response) => {
            let obj = {};
            if (response.address) {
              obj = response.address;
              obj.address = handleText(obj.address);
              this.$store.commit("SENDselectaddress", obj);
            }
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });
      },
      timeClick(value) {
        // this.checkDate();
        // if (Number(this.day + "" + value) < this.noTime) {
        //   return this.$toast({ message: "该上门时间已过", duration: 2000 });
        // }
        this.time = this.day + "" + value;
        this.checkTrue();
      },
      checkDate() {
        if (this.day > 0) return false;
        let hour = new Date().getHours();
        if (hour < 9) {
          this.noTime = 0;
        } else if (hour < 11) {
          this.noTime = 1;
        } else if (hour < 13) {
          this.noTime = 2;
        } else if (hour < 15) {
          this.noTime = 3;
        } else if (hour < 17) {
          this.noTime = 4;
        } else {
          this.day = 1;
          this.noTime = 5;
        }
      },
      getdata() {
        let toast = this.$toast.loading({
          mask: false,
          duration: 0,
        });
        this.$commonPost({
          jydm: "flow_40002",
          flow_40002: {
            refund_nbr: this.$route.query.nbr,
            wechat_version: "1",
          },
        })
          .then((response) => {
            if (this.type == "0") {
              if (response.supplier_address) {
                this.active = 0;
                this.menuShow = true;
              } else {
                this.active = 1;
                this.menuShow = false;
              }
            } else {
              this.active = 1;
              this.menuShow = false;
            }

            //          if (response.supplier_address_self) {
            //            response.supplier_address_self = response.supplier_address_self
            //              .replace("-", "")
            //              .replace("-", "")
            //              .replace("-", "");
            //          }
            this.detail = response;
            // && response.is_full_postage_pay=='0'
            if (!(parseFloat(response.postage_safe || '0') <= 0)) this.pickPayShow = true
            toast.clear();
          })
          .catch((err) => {
            toast.clear();
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });
      },
      initPage() {
        let option = {
          title: "有米@" + this.userInfo.name + "的店铺",
          desc: "欢迎光临我的店铺",
          link: location.origin + "/?supNbr=" + this.userInfo.nbr,
          images: this.userInfo.imgUrl,
        };
        this.weChatShare(option);
        if (!this.keepAlive) this.getdata();
      },
    },

    activated() {
      function addDate(days) {
        let d = new Date();
        d.setDate(d.getDate() + days);
        let m = d.getMonth() + 1;
        let day = d.getDate();
        return `${d.getFullYear()}-${m < 10 ? "0" + m : m}-${day < 10 ? "0" + day : day
          }`;
      }

      this.type = this.$route.query.type || "0";
      document.title = this.type == "0" ? "我要寄件" : "修改物流";
      this.initPage();
      let timeArr = [];
      for (let i = 0; i < 3; i++) {
        let obj = {
          text: i == 0 ? "今天" : i == 1 ? "明天" : "后天",
          date: addDate(i),
          times: [],
        };
        timeArr.push(obj);
      }
      this.timeArr = timeArr;
      if (this.selectaddress.nbr) {
        this.getkdniaoTime();
        this.predictPrice();
      }
      // this.getkdniaoTime()
      // this.predictPrice()
      //if (!this.keepAlive) this.getAddress();
    },
    created() {
      let kdnExpress = this.kdnExpress;
      this.addressData = Object.keys(kdnExpress);
    },
    mounted() { },
    beforeRouteLeave(to, from, next) {
      this.keepAlive = to.name == "addresslist";
      if (to.name != "addresslist") {
        this.$store.commit("SENDselectaddress", "");
        this.voucherImg = "";
        this.aliName = "";
        this.aliAccount = "";
        this.expressName = "";
        this.expressId = "";
        this.goodsType = "";
        this.expressPrice = "0.0";
        this.time = -1;
        this.agree = true;
        this.weight = 1;
        this.active = -1;
        this.menuShow = false;
        this.detail = {};
      }
      next();
    },
  };
</script>
<style scoped lang='stylus'>
  .van-button {
    line-height: 0;
  }
</style>
<style scoped lang='less'>
  .wrapper {
    width: 100%;
    height: 100vh;
    background: #f5f5f5;
  }

  .top {
    height: calc(100vh - 0.98rem);
    width: 100%;
    padding-bottom: 1rem;
    box-sizing: border-box;
    overflow-y: scroll;

    .boxContainer {
      width: 100%;
      /* padding: 0.2rem 0; */
      display: flex;
      justify-content: center;
      background: #fff;
    }

    .itemBox {
      width: 6.9rem;
      background: #fff;

      .list {
        padding: 0.24rem 0;
        height: 2.3rem;
        box-sizing: border-box;
        width: 100%;

        .item {
          width: 100%;
          display: flex;

          img {
            width: 1.8rem;
            height: 1.8rem;
            object-fit: cover;
            border-radius: 0.16rem;
          }

          .rightArea {
            margin-left: 0.14rem;
            position: relative;
            flex: 1;

            .commodityName {
              font-size: 0.26rem;
              font-weight: 500;
              color: #333;
              line-height: 0.32rem;
            }

            .property {
              margin-top: 0.1rem;
              font-size: 0.22rem;
              font-weight: 500;
              color: #999;
              line-height: 0.3rem;
            }

            .last {
              position: absolute;
              bottom: 0;
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;

              .price {
                font-size: 0.3rem;
                color: #e52b25;
                font-weight: 500;
              }

              .quantity {
                font-size: 0.24rem;
                color: #333;
                font-weight: bold;
              }
            }
          }
        }
      }
    }

    .postAddress {
      padding: 0.3rem;
      font-size: 0.26rem;
      color: #999;
      line-height: 0.32rem;
      background: #fff;
      display: flex;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0.3rem;
        height: 1px;
        width: calc(100% - 0.6rem);
        background: #eee;
      }

      .postKey {
        white-space: nowrap;
      }

      .right {
        flex: 1;
        margin-left: 0.2rem;

        .postTop {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          /* margin-bottom: 0.1rem; */
          color: #333;

          .left {
            width: 4.26rem;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-start;

            span {
              display: inline-block;
            }
          }

          .copyBtn {
            width: 1.12rem;
            height: 0.4rem;
            border-radius: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #333;

            span {
              font-size: 0.2rem;
              color: #333;
            }
          }
        }
      }
    }

    .pickAddress {
      margin-top: .20rem;
      width: 100%;
      box-sizing: border-box;
      background: #fff;
      box-sizing: border-box;
      padding-right: .24rem;

      .flexItem {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }

      .pickItemLeft {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 1.64rem;
        height: 1.6rem;

        .line {
          flex: 1;
          width: .04rem;
          background: #fff;
        }

        .circle {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: .9rem;
          height: .9rem;
          border-radius: .45rem;
          box-sizing: border-box;

          span {
            font-size: .22rem;
            color: #fff;
            line-height: .3rem;
            font-weight: 500;
          }
        }
      }

      .pickItemRight {
        width: 5.62rem;
        height: 1.6rem;
        box-sizing: border-box;
        padding: .26rem 0 .24rem;
        font-size: .26rem;
        color: #333;

        .arrow {
          width: 0.3rem;
          height: 0.3rem;
          margin-left: 0.05rem;
        }

        .addressDesc {
          margin-top: 0.1rem;
          word-break: break-all;
          line-height: .32rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }

    .itemSelect {
      margin-top: 0.2rem;

      .title {
        display: flex;
        align-items: center;
        background: #fff;

        .titleKey {
          padding-left: 0.24rem;
          font-size: 0.3rem;
          font-weight: 500;
          color: #333;
        }

        .timeCountBox {
          display: flex;
          align-items: center;
          font-size: 0.3rem;
          font-weight: 500;
          color: #333;
          padding-right: 0.24rem;

          .timeA {
            font-size: 0.24rem;
            font-weight: 500;
            color: #fff;
            width: 0.44rem;
            height: 0.44rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #000;
            border-radius: 0.08rem;
            margin: 0 0.06rem;
          }
        }

        .span {
          color: #333;
          font-size: 0.34rem;
          font-weight: 400;
          flex: 1;
          height: 0.84rem;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;

          &.active {
            color: #e52b25;
          }

          &.active::after {
            content: "";
            width: 1.02rem;
            height: 0.04rem;
            border-radius: 0.02rem;
            background: #e52b25;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }

      .expressTitle {
        background: #fff;
        height: 1.16rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.34rem;
        font-weight: bold;
        color: #333;
        border-top: 1px solid #eee;
      }

      .expressInput {
        background: #fff;
        padding-bottom: 0.34rem;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        input {
          width: 6.9rem;
          height: 0.88rem;
          border-radius: 0.44rem;
          background: #f5f5f5;
          color: #333;
          border: 0;
          padding: 0 0.44rem;
          box-sizing: border-box;
        }
      }

      .expressNotice {
        display: flex;
        flex-direction: column;
        margin-top: 0.1rem;
        padding: 0 0.2rem;
        box-sizing: border-box;

        span {
          line-height: 0.3rem;
          color: #999;
          font-weight: 500;
          font-size: 0.22rem;
        }
      }

      .item {
        padding: 0.3rem;
        border-top: 1px solid #eee;
        background: #fff;
        display: flex;
        justify-content: space-between;
        font-size: 0.26rem;
        font-weight: 500;
        line-height: 0.32rem;

        .key {
          color: #999;
          width: 1.04rem;
          line-height: 0.32rem;
          white-space: nowrap;
        }

        .selectRight {
          display: flex;
          flex: 1;
          align-items: center;
          justify-content: flex-end;
          margin-left: 0.36rem;

          img {
            width: 0.3rem;
            height: 0.3rem;
            margin-left: 0.05rem;
          }

          .flex {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }

        .selectInput {
          display: flex;
          align-items: center;
          border-radius: 0.31rem;
          height: 0.56rem;
          border: 1px solid #e5e5e5;

          .less,
          .more {
            width: 0.66rem;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.4rem;
          }

          input {
            width: 1.34rem;
            display: flex;
            align-items: center;
            text-align: center;
            background: #f5f5f5;
            height: 0.5rem;
            border: 0;
          }
        }

        .predict {
          font-size: 0.34rem;
          color: #e52b25;
          font-weight: bold;

          span {
            font-size: 0.2rem;
          }
        }
      }
    }

    .tip {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-end;
      height: 0.44rem;
      background: #fff;
      padding-right: 0.3rem;

      span {
        font-size: 0.22rem;
        color: #999;
        font-weight: 500;
        line-height: 0.24rem;
      }
    }

    .agree {
      padding: 0.19rem 0.24rem;
      display: flex;

      .radius {
        width: 0.24rem;
        height: 0.24rem;
        border: 1px solid #aeaeae;
        border-radius: 50%;
        box-sizing: border-box;
        margin-right: 0.14rem;

        &.active {
          border: 0.06rem solid #ff0000;
        }
      }

      .agreeText {
        display: flex;
        color: #999;
        font-size: 0.22rem;
        font-weight: 500;

        span {
          color: #1890ff;
        }
      }
    }
  }

  .bottomC {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .bottom {
    height: 0.98rem;
    padding: 0 0.24rem;
    background: #fff;
    display: flex;
    justify-content: space-between;
    position: relative;
    align-items: center;

    .notice {
      position: absolute;
      top: -0.38rem;
      color: #999;
      font-size: 0.22rem;
    }

    .bRight {
      display: flex;
      flex-direction: column;

      span {
        font-size: 0.24rem;
        line-height: 0.3rem;
        color: #999;
      }

      .expressPrice {
        color: #e52b25;
        margin-top: 0.06rem;
        display: inline-block;
        font-weight: bold;
      }
    }

    .apply {
      width: 2.1rem;
      height: 0.8rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.3rem;
      color: #ffe6e6;
      border-radius: 0.4rem;
      background: #ffc3c1;
      transition: all 0.3s;

      &.active {
        background: #e52b25;
      }
    }
  }

  .timeBox {
    background: #fff;
    width: 100%;
    height: 7.89rem;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    padding-top: 1px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;

    .xpng {
      position: absolute;
      width: 0.28rem;
      height: 0.28rem;
      top: 0.37rem;
      right: 0.24rem;
    }

    .timeTitle {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0.3rem 0;
      font-size: 0.34rem;
      font-weight: 500;
    }

    .timeMain {
      display: flex;
      flex: 1;

      .timeMainLeft {
        width: 2.72rem;
        height: 100%;
        background: #f6f6f6;

        .timeKey {
          height: 1.3rem;
          border-bottom: 1px solid #ccc;
          font-size: 0.34rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 500;
          color: #333;
          transition: all 0.2s;

          &.active {
            color: #1890ff;
            background: #fff;
          }
        }
      }

      .timeMainRight {
        flex: 1;
        height: 100%;
        padding-left: 0.28rem;
        box-sizing: border-box;

        .timeValue {
          height: 0.94rem;
          border-bottom: 1px solid #ccc;
          font-size: 0.34rem;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 500;
          color: #333;
          transition: all 0.2s;

          &.active {
            color: #1890ff;
            background: #fff;
          }

          &.no {
            color: #ccc;
            background: #fff;
          }
        }
      }
    }
  }

  .getExpressNotice {
    text-align: center;
    margin-top: 0.26rem;
    color: #999;
    font-size: 0.24rem;
    font-weight: 500;
  }

  .uploadWrap {
    margin-top: 0.2rem;
    background: #fff;
    padding-bottom: 0.32rem;
  }

  .photoArea {
    height: 1.34rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .photoItem {
      width: 1.34rem;
      height: 1.34rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .photoCenter {
        width: 1.34rem;
        height: 1.34rem;
        border: 1px dashed #979797;
        border-radius: 0.04rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .img {
          width: 1.13rem;
          height: 1.13rem;
        }

        .icon {
          width: 1.34rem;
          height: 1.34rem;
        }
      }
    }
  }

  .reminder {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 6.1rem;
    background: #fff;
    box-sizing: border-box;
    padding-top: 0.5rem;

    .reminderimg {
      width: 0.62rem;
      height: 0.62rem;
    }

    .reminderTitle {
      margin-top: 0.2rem;
      height: 0.45rem;
      line-height: 0.45rem;
      color: #333;
      font-size: 0.32rem;
      font-weight: bold;
    }

    .reminderDesc {
      width: 4.43rem;
      line-height: 0.44rem;
      color: #999;
      font-size: 0.28rem;
      text-align: center;
      margin: 0.24rem 0 0.3rem;
    }

    .reminderBtn {
      width: 100%;
      height: 0.85rem;
      border-top: 1px solid #e6e9ed;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      span {
        color: #ff3d3d;
        font-size: 0.28rem;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/information/expressApply.vue